import AxiosInterceptor from 'api/interceptor';

const slider = new AxiosInterceptor();

export default {
    getList(){
        return slider.get('/site/home-slider');
    },
    uploadFile(file){
        let formData = new FormData();
        formData.append('file', file);
        formData.append('type', 'sliders');
        return slider.post('/media/upload',formData);
    },
    addSlider(slide){
        return slider.post('/site/home-slider',slide);
    },
    getSlider(id){
        return slider.get('/site/home-slider/'+id);
    },
    updateSlider(params){
        return slider.put('/site/home-slider/'+params.id,params);
    },
    removeSlider(id){
        return slider.delete('/site/home-slider/'+id);
    },
    saveList(list){
        return slider.put('/site/home-slider/save',{list: list});
    }
};